import {BenchlingTypeDef} from './BenchlingTypeDef';

// Keep in sync with benchling/data_types/benchling_type_def/complex_types.py
export enum ComplexTypeOperator {
  LIST = 'List',
  NULLABLE = 'Nullable',
  UNION = 'Union',
}

export const FACTORY_SUPPORTED_COMPLEX_TYPES: Array<ComplexTypeOperator> = [
  ComplexTypeOperator.LIST,
  ComplexTypeOperator.NULLABLE,
  ComplexTypeOperator.UNION,
];

export const COMPLEX_TYPE_TO_FACTORY: {
  [op in ComplexTypeOperator]: (...baseTypes: Array<BenchlingTypeDef>) => ComplexType;
} = {
  [ComplexTypeOperator.LIST]: (baseType: BenchlingTypeDef) => new List(baseType),
  [ComplexTypeOperator.NULLABLE]: (baseType: BenchlingTypeDef) => new Nullable(baseType),
  [ComplexTypeOperator.UNION]: (...baseTypes: Array<BenchlingTypeDef>) => new Union(new Set(baseTypes)),
};

export abstract class ComplexType {
  abstract getOperatorName: () => string;
  abstract getBaseTypes: () => Array<BenchlingTypeDef>;
}

abstract class ModifierTypeDef extends ComplexType {
  ofType: BenchlingTypeDef;

  constructor(ofType: BenchlingTypeDef) {
    super();
    this.ofType = ofType;
  }

  getBaseTypes: () => Array<BenchlingTypeDef> = () => [this.ofType];
}

export class List extends ModifierTypeDef {
  getOperatorName: () => string = () => ComplexTypeOperator.LIST;
}

export class Nullable extends ModifierTypeDef {
  getOperatorName: () => string = () => ComplexTypeOperator.NULLABLE;
}

export class Union extends ComplexType {
  allowedTypes: Set<BenchlingTypeDef>;

  constructor(allowedTypes: Set<BenchlingTypeDef>) {
    super();
    this.allowedTypes = allowedTypes;
  }

  getOperatorName: () => string = () => ComplexTypeOperator.UNION;

  getBaseTypes: () => Array<BenchlingTypeDef> = () => Array.from(this.allowedTypes);
}
